import { combineReducers } from '@reduxjs/toolkit';
import uiReducer from './uiSlice';
import fillerTypeSlice from './FillerTypeSlice';
import fabricTypeSlice from './FabricTypeSlice';
import categoryReducer from './CategorySlice';
import commonSlice from './CommonSlice';
import productReducer from './ProductSlice';
import userSlice from './UserSlice';
import authReducer, { clearSession } from './AuthSlice';
import adminUsersReducer from './AdminUsersSlice';
import promocodeReducer from './PromoCodeSlice';
import prodGroupReducer from './ProdGroupSlice';
import reviewsReducer from './ReviewsSlice';

const appReducer = combineReducers({
    ui: uiReducer,
    common: commonSlice,
    category: categoryReducer,
    product: productReducer,
    fillerType: fillerTypeSlice,
    fabricType: fabricTypeSlice,
    user: userSlice,
    auth: authReducer,
    adminUsers: adminUsersReducer,
    promocode: promocodeReducer,
    prodGroup: prodGroupReducer,
    reviews: reviewsReducer,
});

// При LOGOUT сбрасываем auth slice до initialState
const rootReducer = (state: any, action: any) => {
    if (action.type === clearSession.type) {
        state = { ...state, auth: undefined, reviews: undefined };
        // Или полностью очистить состояние:
        // state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
